import { ReactNode } from "react";
import { ReactComponent as Control } from "assets/console/menu_control.svg";
import { ReactComponent as Air } from "assets/console/menu_air.svg";
import { ReactComponent as Quick } from "assets/console/menu_quick.svg";
import { ReactComponent as Express } from "assets/console/menu_express.svg";
import { ReactComponent as Morning } from "assets/console/menu_morning.svg";
import { ReactComponent as Service } from "assets/console/menu_service.svg";
import { ReactComponent as Manage } from "assets/console/menu_manage.svg";

export type NavItem = {
    menu: string;
    path: string | string[];
    icon?: ReactNode;
    sub_menu?: NavItem[];
};

export const NAV: NavItem[] = [
    // {
    //     menu: "관제",
    //     path: "/logistics-monitoring",
    //     icon: <Control />,
    // },
    {
        menu: "항공해운",
        path: "/air",
        icon: <Air />,
        sub_menu: [
            {
                menu: "고객서비스",
                path: [
                    "/air/customer/pickup",
                    "/air/customer/estimate",
                    "/air/customer/supplies",
                    "/air/customer/supplies/:idx",
                    "/air/bl-image",
                ],
                icon: <Service />,
                sub_menu: [
                    {
                        menu: "화물픽업예약",
                        path: ["/air/customer/pickup"],
                    },
                    {
                        menu: "운송견적문의",
                        path: ["/air/customer/estimate"],
                    },
                    {
                        menu: "운송장 및 부자재 요청",
                        path: ["/air/customer/supplies", "/air/customer/supplies/:idx"],
                    },
                    {
                        menu: "BL 이미지",
                        path: "/air/bl-image",
                    },
                ],
            },
            {
                menu: "사이트 관리",
                path: [
                    "/air/manage/notices",
                    "/air/manage/notices/:idx",
                    "/air/manage/notices/create",
                    "/air/manage/popups",
                    "/air/manage/popups/:idx",
                    "/air/manage/popups/create",
                ],
                icon: <Manage />,
                sub_menu: [
                    {
                        menu: "공지사항",
                        path: ["/air/manage/notices", "/air/manage/notices/:idx", "/air/manage/notices/create"],
                    },
                    {
                        menu: "팝업관리",
                        path: ["/air/manage/popups", "/air/manage/popups/:idx", "/air/manage/popups/create"],
                    },
                ],
            },
        ],
    },
    {
        menu: "모닝택배",
        path: "/morning",
        icon: <Morning />,
        sub_menu: [
            {
                menu: "고객서비스",
                path: [
                    "/morning/customer/qr-system-request",
                    "/morning/customer/qr-system-request/:idx",
                    "/morning/customer/invoices-edit",
                    "/morning/customer/invoices-edit/:idx",
                    "/morning/customer/supplies",
                    "/morning/customer/supplies/:idx",
                    "/morning/customer/driver",
                    "/morning/customer/driver/create",
                    "/morning/customer/driver/:idx",
                    "/morning/customer/warehouse",
                    "/morning/customer/warehouse/create",
                    "/morning/customer/warehouse/:idx",
                    "/morning/customer/driver-schedule",
                    "/morning/customer/driver-schedule/create",
                    "/morning/customer/driver-schedule/:idx",
                    "/morning/customer/holiday",
                ],
                icon: <Service />,
                sub_menu: [
                    {
                        menu: "QR시스템 코드 신청",
                        path: ["/morning/customer/qr-system-request", "/morning/customer/qr-system-request/:idx"],
                    },
                    {
                        menu: "청구서수정요청",
                        path: ["/morning/customer/invoices-edit", "/morning/customer/invoices-edit/:idx"],
                    },
                    {
                        menu: "운송장 신청접수",
                        path: ["/morning/customer/supplies", "/morning/customer/supplies/:idx"],
                    },
                    {
                        menu: "기사 관리",
                        path: ["/morning/customer/driver", "/morning/customer/driver/create", "/morning/customer/driver/:idx"],
                    },
                    {
                        menu: "입고지 관리",
                        path: ["/morning/customer/warehouse", "/morning/customer/warehouse/create", "/morning/customer/warehouse/:idx"],
                    },
                    {
                        menu: "일자별 입고지 기사 관리",
                        path: [
                            "/morning/customer/driver-schedule",
                            "/morning/customer/driver-schedule/create",
                            "/morning/customer/driver-schedule/:idx",
                        ],
                    },
                    {
                        menu: "휴무일 관리",
                        path: ["/morning/customer/holiday"],
                    },
                ],
            },
            {
                menu: "채용지원",
                path: ["/morning/customer/recruitment"],
                icon: <Service />,
                // sub_menu: [
                //     {
                //         menu: "채용공고",
                //         path: "",
                //     },
                // ],
            },
            {
                menu: "사이트 관리",
                path: [
                    "/morning/manage/notices",
                    "/morning/manage/notices/:idx",
                    "/morning/manage/notices/create",
                    "/morning/manage/popups",
                    "/morning/manage/popups/:idx",
                    "/morning/manage/popups/create",
                    "/morning/manage/faq",
                    "/morning/manage/faq/:idx",
                    "/morning/manage/faq/create",
                ],
                icon: <Manage />,
                sub_menu: [
                    {
                        menu: "공지사항",
                        path: ["/morning/manage/notices", "/morning/manage/notices/:idx", "/morning/manage/notices/create"],
                    },
                    {
                        menu: "팝업관리",
                        path: ["/morning/manage/popups", "/morning/manage/popups/:idx", "/morning/manage/popups/create"],
                    },
                    {
                        menu: "FAQ",
                        path: ["/morning/manage/faq", "/morning/manage/faq/:idx", "/morning/manage/faq/create"],
                    },
                ],
            },
        ],
    },
    {
        menu: "모닝퀵",
        path: "/quick",
        icon: <Quick />,
        sub_menu: [
            {
                menu: "고객서비스",
                path: ["/quick/customer/quick-order"],
                icon: <Service />,
                sub_menu: [
                    {
                        menu: "퀵&화물 인터넷접수",
                        path: ["/quick/customer/quick-order"],
                    },
                ],
            },
            {
                menu: "사이트 관리",
                path: [
                    "/quick/manage/notices",
                    "/quick/manage/notices/:idx",
                    "/quick/manage/notices/create",
                    "/quick/manage/popups",
                    "/quick/manage/popups/:idx",
                    "/quick/manage/popups/create",
                    "/quick/manage/faq",
                    "/quick/manage/faq/:idx",
                    "/quick/manage/faq/create",
                ],
                icon: <Manage />,
                sub_menu: [
                    {
                        menu: "공지사항",
                        path: ["/quick/manage/notices", "/quick/manage/notices/:idx", "/quick/manage/notices/create"],
                    },
                    {
                        menu: "팝업관리",
                        path: ["/quick/manage/popups", "/quick/manage/popups/:idx", "/quick/manage/popups/create"],
                    },
                    {
                        menu: "FAQ",
                        path: ["/quick/manage/faq", "/quick/manage/faq/:idx", "/quick/manage/faq/create"],
                    },
                ],
            },
        ],
    },
    {
        menu: "특송화물",
        path: "/express",
        icon: <Express />,
        sub_menu: [
            {
                menu: "고객서비스",
                path: ["/express/customer/express-order", "/express/customer/express-order/:idx"],
                icon: <Service />,
                sub_menu: [
                    {
                        menu: "특송화물 인터넷접수",
                        path: ["/express/customer/express-order", "/express/customer/express-order/:idx"],
                    },
                ],
            },
            {
                menu: "사이트 관리",
                path: [
                    "/express/manage/notices",
                    "/express/manage/notices/:idx",
                    "/express/manage/notices/create",
                    "/express/manage/popups",
                    "/express/manage/popups/:idx",
                    "/express/manage/popups/create",
                    "/express/manage/faq",
                    "/express/manage/faq/:idx",
                    "/express/manage/faq/create",
                ],
                icon: <Manage />,
                sub_menu: [
                    {
                        menu: "공지사항",
                        path: ["/express/manage/notices", "/express/manage/notices/:idx", "/express/manage/notices/create"],
                    },
                    {
                        menu: "팝업관리",
                        path: ["/express/manage/popups", "/express/manage/popups/:idx", "/express/manage/popups/create"],
                    },
                    {
                        menu: "FAQ",
                        path: ["/express/manage/faq", "/express/manage/faq/:idx", "/express/manage/faq/create"],
                    },
                ],
            },
        ],
    },
];
